import React, { useState } from 'react'
import { Box, Card, Typography, CardContent, CardMedia, Checkbox, Divider, Grid, Stack } from '@mui/material'
import artist from '../../img/userAdmin.png'
import { getDateAsPerFormat } from '../../_helpers/reusablefunctions/dateSetter'
import { useHistory , Link } from 'react-router-dom'
import { verificationStatusColor } from './verificationStatusColor'

const ArtistListCardLayout = ({ cardData, moduleName }) => {
  const [selected, setSelected] = useState([]);
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const history = useHistory();
  const genreNames = cardData.genres.map((genre) => (<span key={genre.id}>{genre.genre}</span>));
  const genreString = genreNames.join(', ');

  return (
    <Card variant="outlined" className="shadow-table mt-4" sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        
        {/* Image, Name, and Verification */}
        <Stack 
          direction={{ xs: "column", sm: "row" }} 
          spacing={2} 
          alignItems="center"
          sx={{ p: 2, justifyContent: "space-between", textAlign: { xs: "center", sm: "left" } , position:'relative'}}
        >
          {/* Avatar + Name */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Link to={`/artistdetail/${cardData?.userHandle}`}>
            <CardMedia
              component="img"
              sx={{ 
                width: { xs: '48px', sm: '56px' }, 
                height: { xs: '48px', sm: '56px' }, 
                borderRadius: '50%' 
              }}
              image={cardData?.avatar_url ? cardData?.avatar_url : cardData.avatar ? `${process.env.REACT_APP_CREATORURL_MEDIA}/media/${cardData.avatar}` : artist}
            />
            </Link>
            <Typography variant="body2" >{cardData.name}</Typography>
          </Stack>

          <Typography variant='span' sx={{position:'absolute' , top:'10px' , right:'10px'}}
            className={`${verificationStatusColor(cardData?.verification_status?.verificationStatus)} verifyStatus`}
          >
            {cardData?.verification_status?.verificationStatus || 'Unverified'}
          </Typography>
        </Stack>

        {/* Divider */}
        <Divider />

        {/* Date Section */}
        <CardContent sx={{ p: 2 }}>
          <Typography variant="body2">
            <strong>Date:</strong> {getDateAsPerFormat(cardData.date_joined, "DD Mon, YYYY")}
          </Typography>
        </CardContent>
        
      </Box>
    </Card>
  );
}

export default ArtistListCardLayout